import { useState, useRef } from 'react';
import { BiComment, BiSend } from 'react-icons/bi';
import { useOnClickOutside } from 'usehooks-ts';
import EmojiPicker from './EmojiPicker';

import { useAuthContext } from '../hooks/useAuthContext';
import { useQuery, useMutation } from "@apollo/client";
import { ADD_COMMENT } from '../mutations/commentMutations';
import { GET_POST } from "../queries/postQueries";

export default function AddCommentButton({ postId }) {
  const { data, refetch } = useQuery(GET_POST, { variables: { id: postId } })
  const [content, setContent] = useState('')
  const [commentMode, setCommentMode] = useState(false)

  const { authUser } = useAuthContext()
  const commentRef = useRef(null)

  const [addComment] = useMutation(ADD_COMMENT, {
    variables: { content, userId: authUser.id, postId },
    onCompleted: () => {
      refetch()
    },
    onError: (error) => {
      throw new Error(error.message)
    }
  })

  const handleClickOutside = (e) => {
    if (commentRef.current && !commentRef.current.contains(e.target)) {
      e.stopPropagation()
      setCommentMode(false)
    }
  }
  
  useOnClickOutside(commentRef, handleClickOutside)

  const writeComment = () => {
    if (content === '') {
      return alert('Please fill up the content')
    }

    addComment({ variables: { content, userId: authUser.id, postId }})

    setCommentMode(false)
    setContent('')
  }

  const countComments = () => {
    let count = data.post.comments.length

    for (const comment of data.post.comments) {
      count += comment.replies.length
    }

    return count
  }

  return (
    <span ref={commentRef}>
      <button
        type='button'
        className='btn btn-sm btn-violet'
        onClick={() => {
          setContent('')
          setCommentMode(!commentMode)
        }}
      >
        <div className='d-flex rfs-4'>
          {data && data.post.comments.length > 0 && (
            <div className="me-1">
              {countComments()}
            </div>
          )}

          <div>
            <BiComment className='icon' />
          </div>
        </div>
      </button>
      
      {commentMode && (
        <div className="d-flex mt-3 mb-1 container">
          <EmojiPicker content={content} setContent={setContent} />

          <input
            className="form-control me-1 rfs-5"
            placeholder="Add a comment..."
            id='content'
            value={content}
            autoFocus
            onChange={(e) => setContent(e.target.value)}
          />
          
          <BiSend className="my-auto cursor-pointer" onClick={writeComment} />
        </div>
      )}
    </span>
  )
}
